import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class UpdateForyngringsMetodCommand extends BasicCommand<UpdateForyngringsMetodCommand> {
    readonly atgardGuid: string;
    readonly metod: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateForyngringsMetodCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "AnmalanTradslag";

    get primaryKey(): IPrimaryKey<UpdateForyngringsMetodCommand> {
        return {
            guid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, metod: string) {
        super(UpdateForyngringsMetodCommand.$type, UpdateForyngringsMetodCommand.$groupKey, CommandType.Replace);
        this.atgardGuid = atgardGuid;
        this.metod = metod;
    }
}
